import _ from "lodash";
import {getAppsPositionConfig} from "./getAppsPositionConfig";

export const getAppsPositionSecond = (type, apps) => {
    const config = getAppsPositionConfig(type);

    let sorted = [];
    let names = [];

    _.forEach(config, app => {
        _.forEach(apps, (a) => {
            if (a.name === app) {
                sorted = [ ...sorted, a ];
                names = [ ...names, a.name ];
            }
        })
    });

    _.forEach(apps, (a) => {
        if (!_.includes(names, a.name)) {
            if (type === 'eshops' && a.name === 'Blank') {
            } else {
                sorted = [ ...sorted, a ];
            }
        }
    });

    if (type === 'eshops') {
        // Add Blank to end
        _.forEach(apps, (a) => {
            if (!_.includes(names, a.name)) {
                if (a.name === 'Blank') {
                    sorted = [ ...sorted, a ];
                }
            }
        });
    }

    return sorted;
};
